/** Public-folder SVGs rather than imported data URIs, for a smaller bundle and cacheable flags. */

/** Keyed by ISO 639-1. */
export const flagUrls: Record<string, string> = {
	ca: '/flags/ca.svg',
	de: '/flags/de.svg',
	en: '/flags/en.svg',
	es: '/flags/es.svg',
	eu: '/flags/eu.svg',
	fr: '/flags/fr.svg',
	gl: '/flags/gl.svg',
	it: '/flags/it.svg',
	nl: '/flags/nl.svg',
	pt: '/flags/pt.svg',
};

export const countryCodeToLocale: Record<string, string> = {
	AD: 'ca',
	AT: 'de',
	DE: 'de',
	ES: 'es',
	FR: 'fr',
	GB: 'en',
	IT: 'it',
	NL: 'nl',
	PT: 'pt',
	US: 'en',
};

const localeNames: Record<string, string> = {
	ca: 'Català',
	de: 'Deutsch',
	en: 'English',
	es: 'Español',
	eu: 'Euskera',
	fr: 'Français',
	gl: 'Galego',
	it: 'Italiano',
	nl: 'Nederlands',
	pt: 'Português',
};

export function Flag({ locale, className, ...props }: { locale: string } & React.ImgHTMLAttributes<HTMLImageElement>) {
	const src = flagUrls[locale];
	if (!src) return null;
	return <img src={src} alt={localeNames[locale] ?? locale} width={20} height={20} className={className} {...props} />;
}
